"use client";

import React from "react";

import type { Props as MediaProps } from "../../types/Media";
import { cn } from "@onclicks/sharedcomponents/ui";
import type { MediaDoc } from "../../types/payload";

export const PdfMedia: React.FC<MediaProps> = (props) => {
  const { resource, className } = props;

  const url = ((resource as MediaDoc)?.url || "") as string;

  if (
    resource &&
    typeof resource === "object" &&
    url &&
    typeof url === "string"
  ) {
    return (
      <div className="flex flex-col mb-5 justify-center">
        <object
          data={url}
          type="application/pdf"
          className={cn("w-[65%] mx-auto h-160", className)}
        >
          <p>
            Your browser does not support PDFs.
            <a href={url}>Download the PDF</a>.
          </p>
        </object>
        <a
          href={url}
          className="bg-gradient-to-br from-[#FFB347] to-[#FB7303] hover:from-[#e66902] hover:to-[#e66902] rounded-full p-4 mx-auto mt-3 text-white"
        >
          Télécharger le menu
        </a>
      </div>
    );
  }

  return null;
};
